<!-- <require from="@ia-widgets/phone-number/ia-phone-number"></require> -->
<containerless></containerless>

<div class="section-details">
    <h3>${pageTitle}</h3>
</div>

<template if.bind="showRegistrationForm">
    <div if.bind="alertMessage.length > 0">
        <span class="alert alert-${alertType}" role="alert">
            <span repeat.for="alert of alertMessage">${alert.message}</br></span>
        </span>
    </div>

    <template if.bind="!isRegistered">
        <div>
            <tooltip hidden="true"></tooltip>
            <label for="email">Email</label>
            <div>
                <input class="input" type="text" name="email" value.bind="email & validate:'manual'"/>
            </div>
        </div>
        <div>
            <tooltip hidden="true"></tooltip>
            <label for="password">Password</label>
            <div>
                <input class="input" type="password" name="password" value.bind="password & validate:'manual'" />
            </div>
        </div>
        <div>
            <tooltip hidden="true"></tooltip>
            <label for="confirm_password">Confirm password</label>
            <div>
                <input class="input" type="password" name="confirm_password"  value.bind="confirm_password & validate:'manual'" />
            </div>
        </div>
        <div class="row row-align-right">
            <button id="registerBtn" type="button" click.trigger="register()" disabled.bind="registerBtnDisabled">Register</button>
        </div>
        <div class="row row-align-right">
            <a href="#" external click.trigger="toggleLoginRegister()" show.bind="!registerBtnDisabled">already have an account?</a>
        </div>

    </template>
</template>

<template if.bind="!showRegistrationForm">
    <div if.bind="alertMessage.length > 0">
        <span class="alert alert-${alertType}" role="alert">
            <span repeat.for="alert of alertMessage">${alert.message}</br></span>
        </span>
    </div>

    <template if.bind="!loggedin && !forgotPassword && !accountRequiresActivation">
        <div>
            <tooltip hidden="true"></tooltip>
            <label for="email">Email</label>
            <div>
                <input class="input" type="text" name="email"  value.bind="email & validate:'manual'"/>
            </div>
        </div>
        <div>
            <tooltip hidden="true"></tooltip>
            <label for="password">Password</label>
            <div>
                <input class="input" type="password" name="password" value.bind="password & validate:'manual'" />
            </div>
        </div>
        <div class="row row-align-right">
            <button id="loginBtn" type="button" click.trigger="login()" disabled.bind="loginBtnDisabled">Login</button>
        </div>
        <div class="row row-align-right">
            <a href="#" external click.trigger="toggleLoginRegister()" show.bind="!loginBtnDisabled">create a new account?</a>
        </div>
        <div class="row row-align-right">
            <a href="#" external click.trigger="toggleForgotPassword()" show.bind="!loginBtnDisabled">forgot password?</a>
        </div>
    </template>
    <template if.bind="forgotPassword">
        <div if.bind="!passwordReset">
            <tooltip hidden="true"></tooltip>
            <label for="email">Email</label>
            <div>
                <input class="input" type="text" name="email"  value.bind="email & validate:'manual'"/>
            </div>
        </div>

        <div class="row row-align-right">
            <button id="resetBtn" type="button" click.trigger="resetPassword()" disabled.bind="resetBtnDisabled" if.bind="!passwordReset">Reset</button>
        </div>
        <div class="row row-align-right">
            <a href="#" external click.trigger="toggleForgotPassword()" show.bind="!resetBtnDisabled">back to login</a>
        </div>
    </template>
</template>

<template if.bind="accountRequiresActivation">
        <div>
            <tooltip hidden="true"></tooltip>
            <label for="postal_address">Postal address</label>
            <div>
                <input id="postal_address" type="search" name="PostalAddress" value.bind="postalAddress & validate:'manual'">
                <input type="hidden" value.bind="postalAddressModel.displayText" name="displayText">
                <input type="hidden" value.bind="postalAddressModel.address1" name="Address1">
                <input type="hidden" value.bind="postalAddressModel.address2" name="Address2">
                <input type="hidden" value.bind="postalAddressModel.address3" name="Address3">
                <input type="hidden" value.bind="postalAddressModel.suburb" name="Suburb">
                <input type="hidden" value.bind="postalAddressModel.stateCode" name="StateCode">
                <input type="hidden" value.bind="postalAddressModel.postCode" name="PostCode">
                <input type="hidden" value.bind="postalAddressModel.country" name="Country">
                <input type="hidden" value.bind="postalAddressModel.latitude" name="Latitude">
                <input type="hidden" value.bind="postalAddressModel.longitude" name="Longitude">
            </div>

        </div>
        <div>
            <tooltip ><p>Valid Australian landline or mobile numbers must be supplied.</p></tooltip>
            <label for="Phone">Phone</label>
            <div>
                <ia-phone-number phone-number.bind="telephoneNumber & validate:'manual'" show-label.bind="false"></ia-phone-number>
            </div>
        </div>
        <div>
            <tooltip hidden="true"></tooltip>
            <label for="verification_code">Code</label>
            <div>
                <input class="input" type="text" maxlength="6" name="verification_code" value.bind="verification_code & validate:'manual'" />
            </div>
        </div>

        <div class="row row-align-right">
            <button id="resendBtn" type="button" click.trigger="resendActivationCode()">Resend Code</button>
            <button style="margin-left: 15px" id="verifyBtn" type="button" click.trigger="activateRegistration()" disabled.bind="verification_code.length !== 6 || verifyBtnDisabled">Activate</button>
        </div>
</template>

<div class="section-details">
    <h3>Disclaimer</h3>
</div>
<div>
    <label class="reg-confirm-no-margin">By registering to purchase this insurance, I confirm that I have read and understood:</label>
</div>
<div>
    <ul>
        <li><a href="${appService.scheme.newBusinessDodUrl}" target="_blank" external>My Duty of Disclosure</a></li>
        <li><a href="${appService.scheme.schemeFsgUrl}" target="_blank" external>Financial Services Guide & Privacy Collection Notice</a></li>
        <li><a href="${appService.scheme.brokerBinderUrl}" target="_blank" external>Broker Under Binder Disclosure</a></li>
        <li><a href="${appService.scheme.schemeToeUrl}" target="_blank">Terms of Engagement</a></li>
    </ul>
</div>
<div if.bind="appService.scheme.Adviser.Referral">
    <label class="reg-confirm-no-margin">That a referral relationship is in place for this insurance with '${appService.scheme.Adviser.Referral}' and that they will be paid a referral commission if you accept the products offered.</label>
</div>
<div if.bind="appService.scheme.insurerPdsUrls.length > 0">
    <label class="reg-confirm-no-margin">Product Disclosure ${pdsStatementText}:</label>
</div>
<div if.bind="appService.scheme.insurerPdsUrls.length > 0">
    <ul>
        <li repeat.for="pds of appService.scheme.insurerPdsUrls"><a href="http://${pds.url}" target="_blank">${pds.synopsis}</a></li>
    </ul>
</div>